import React, { useState } from "react";
import classes from "./Footer.module.css";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer = ({ socialMedia, whatsAppNumber }) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className={`${classes.footerBottom}`}>
        <div className={`container-fluid`}>
          <div className={`${classes.footerText}`}>
            {t("footer-copyright", { year: new Date().getFullYear() })}
            <a
              className={`${classes.poweredBy}`}
              href="https://2payme.com/"
              target="_blank"
              rel="noreferrer">
              {t("2-pay-me")}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
